document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('size-chart-modal');
  if (!modal) return;

  const openTriggers = document.querySelectorAll('[data-size-chart-open]');
  const closeTriggers = modal.querySelectorAll('[data-size-chart-close]');
  const tabs = modal.querySelectorAll('.size-chart-modal__tab');
  const panels = modal.querySelectorAll('.size-chart-modal__panel');

  const openModal = () => {
    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-chart-open');
  };

  const closeModal = () => {
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-chart-open');
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tabTarget;

      tabs.forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach((p) => p.classList.remove('active'));

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      const matchedPanel = modal.querySelector('[data-tab-panel="' + target + '"]');
      if (matchedPanel) matchedPanel.classList.add('active');
    });
  });
});
